var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLightningBolt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.078,
    x2: 242.701,
    xlinkHref: "#lg1",
    y1: -133.278,
    y2: 562.874
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6519,
    stopColor: "#f67150",
    stopOpacity: 0.652
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.286,
    x2: -80.702,
    xlinkHref: "#lg2",
    y1: 179.798,
    y2: 454.451
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.723,
    x2: 508.301,
    xlinkHref: "#lg1",
    y1: 191.784,
    y2: 191.784
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 471.286,
    x2: 259.013,
    xlinkHref: "#lg2",
    y1: 177.615,
    y2: 245.703
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.592,
    x2: 94.586,
    xlinkHref: "#lg2",
    y1: 341.848,
    y2: 250.843
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.699,
    x2: 149.778,
    xlinkHref: "#lg1",
    y1: 254.994,
    y2: 254.994
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.381,
    x2: -61.67,
    xlinkHref: "#lg2",
    y1: 242.976,
    y2: 300.728
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m345.333 219.596c-24.707 0-41.283-25.368-31.361-47.995l53.69-122.438c10.164-23.177-6.815-49.163-32.124-49.163h-122.742c-13.925 0-26.532 8.237-32.124 20.99l-102.597 233.97c-7.938 18.104 5.323 38.4 25.091 38.4h89.282c18.178 0 31.316 17.378 26.359 34.867l-45.404 160.212c-5.048 17.812 18.13 29.573 29.525 14.982l172.875-221.372c19.821-25.382 1.736-62.453-30.47-62.453z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.928 503.421 172.875-221.372c19.822-25.382 1.736-62.453-30.469-62.453-24.707 0-41.282-25.368-31.36-47.995l53.69-122.438c10.162-23.177-6.817-49.163-32.126-49.163h-48.016l-88.246 207.6c-10.282 24.188 7.469 51.021 33.752 51.021 48.783 0 78.538 53.642 52.712 95.028l-97.508 156.256c5.195.519 10.678-1.338 14.696-6.484z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m432.423 334.056 72.151-113.036c8.958-14.034.958-32.681-15.384-35.862l-40.365-7.856c-14.602-2.842-24.586-16.404-22.962-31.191l9.595-87.374c1.646-14.991-18.073-21.938-26.187-9.226l-71.822 112.52c-9.046 14.172-.793 32.988 15.76 35.932l39.338 6.996c14.822 2.636 25.061 16.311 23.418 31.276l-9.729 88.595c-1.646 14.991 18.073 21.938 26.187 9.226z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.191 185.159-40.365-7.856c-14.602-2.842-24.586-16.404-22.962-31.191l9.595-87.374c.765-6.962-3.081-12.184-8.23-14.513l-32.67 101.29c-5.406 16.759 3.043 34.849 19.363 41.462l18.772 7.606c16.63 6.738 25.033 25.352 19.087 42.281l-36.156 102.951c5.747 2.046 12.731.615 16.799-5.758l72.151-113.036c8.958-14.034.958-32.682-15.384-35.862z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m103.166 293.36h79.208l-37.902-37.902c-2.749-3-6.46-5.218-10.904-6.083l-34.238-6.663c-5.07-.987-9.466-3.514-12.816-6.996l-8.439 19.245c-7.938 18.102 5.324 38.399 25.091 38.399z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m85.418 375.671 61.199-95.878c7.598-11.904.813-27.72-13.049-30.418l-34.238-6.663c-12.385-2.41-20.854-13.914-19.477-26.456l8.139-74.111c1.396-12.715-15.329-18.608-22.212-7.826l-60.92 95.44c-7.673 12.021-.672 27.981 13.368 30.478l33.367 5.934c12.572 2.236 21.257 13.835 19.863 26.528l-8.252 75.147c-1.396 12.714 15.33 18.607 22.212 7.825z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.568 249.375-34.238-6.663c-12.385-2.41-20.854-13.914-19.477-26.456l8.139-74.111c.648-5.905-2.613-10.335-6.981-12.31l-27.711 85.915c-4.585 14.215 2.581 29.559 16.424 35.168l15.922 6.451c14.105 5.715 21.233 21.503 16.19 35.863l-30.668 87.324c4.875 1.735 10.798.522 14.249-4.884l61.199-95.878c7.599-11.905.814-27.722-13.048-30.419z",
    fill: "url(#SVGID_7_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightningBolt);
export default __webpack_public_path__ + "static/media/icon-lightning-bolt.389640f8e70ce840ac6727e446a85cc0.svg";
export { ForwardRef as ReactComponent };